import React from 'react';

const Label = ({ classes, label, tooltip }) => (
  <label className={`${classes} mb-2.5 block text-[#444]`}>
    {label}
    {tooltip && <span className="tooltip">{tooltip}</span>}
  </label>
);

export default Label;
